module.exports = __webpack_public_path__ + "img/campagin-05.ecd9fd62.svg";